import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

interface ItemData2 {
  name: string;
  age: string;
  address: string;
}
interface ItemData {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss'],
})
export class CustomerDetailComponent implements OnInit, OnDestroy {
  listOfData2: ItemData2[] = [];
  listOfData: ItemData[] = [];

  value?: string;

  visible: boolean;
  isEdit: boolean;
  constructor() {
  }
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }

    for (let i = 0; i < 100; i++) {
      this.listOfData.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.isEdit = false;
    this.visible = false;
  }
  
}